import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface ProductListPayload {
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
}

export interface ProductFormPayload {
  product_code: string;
  product_name: string;
  description?: string;
  logo_url?: string;
  theme_colour?: string;
  status_id?: number;
  display_order?: number;
  notes?: string;
}

const list = (payload: ProductListPayload) => {
  const { includeDeleted, page, limit } = payload;
  const params: Record<string, string> = {};
  if (includeDeleted) params.includeDeleted = 'true';
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.masterProducts}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.masterProducts}/${id}`);

const create = (payload: ProductFormPayload) => http.post(API_ENDPOINTS.masterProducts, payload);

const update = (id: number | string, payload: Partial<ProductFormPayload>) =>
  http.patch(`${API_ENDPOINTS.masterProducts}/${id}`, payload);

const remove = (id: number | string) => http.delete(`${API_ENDPOINTS.masterProducts}/${id}`);

export interface ModuleConfigRow {
  product_id: number;
  module_key: string;
  is_enabled: boolean;
  updated_by: number | null;
  updated_at: string;
}

const getModuleConfig = (id: number | string) => http.get(`${API_ENDPOINTS.masterProducts}/${id}/module-config`);

const updateModuleConfig = (id: number | string, moduleKey: string, isEnabled: boolean) =>
  http.patch(`${API_ENDPOINTS.masterProducts}/${id}/module-config`, { moduleKey, isEnabled });

const uploadLogo = (file: File) => {
  const formData = new FormData();
  formData.append('logo', file);
  return http.post(API_ENDPOINTS.masterProductsLogoUpload, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const ProductService = { list, get, create, update, remove, uploadLogo, getModuleConfig, updateModuleConfig };

export default ProductService;
